// extracted by mini-css-extract-plugin
export default {"column":"index_column_3rAwh","tit":"index_tit_ggly6","column_pic":"index_column_pic_Lh-0P","intro_p":"index_intro_p_N-JYM"};